import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import { toast } from "react-toastify";


export default function UpdateLogistic() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const [loading,setLoading] = useState('')

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allCategory, setallCategory] = useState([]);
  const [count,setCount] = useState(0)

 

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  

 


  const [allSubCategory, setallSubCategory] = useState([]);
  
  const {id} = useParams()

  const [CategoryTitle,setCategoryTitle] = useState('');
  const [Category,setCategory] = useState('')
  const [SubCategoryDescription,setSubCategoryDescription] = useState('')
   const [vesselType, setvesselType] = useState("");
    
     const [YearBuilt, setYearBuilt] = useState("");
     const [DWT, setDWT] = useState("");
   
     const [Email, setEmail] = useState("");
     const [MobileNO, setMobileNO] = useState("");
     const [BriefDescription, setBriefDescription] = useState("");
     
     const [OpenArea,setOpenArea] = useState('')
     const [TCVC,setTCVC] = useState('')
     const [CompanyAddress,setCompanyAddress] = useState('');
       const [Company,setCompany] = useState('');
       const [name,setName] = useState('');
    
  const navigate = useNavigate()

  // fetch Category  data
  // Function to merge ship amenities with available amenities
const mergeAmenities = (shipAmenities, allAmenities) => {
  const merged = allAmenities.reduce((acc, amenity) => {
    const found = shipAmenities.find((item) => item.name === amenity.amenities);
    acc[amenity.amenities] = found ? found.value : ""; // If found, set value, else empty
    return acc;
  }, {});
  setFormDataA((prev) => ({ ...prev, ...merged }));
};

// Fetch ship data and categories






  const [amenities, setAmenities] = useState([]);
  const [formDataA, setFormDataA] = useState({});

  // Fetch amenities from the backend
  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
           
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAmenities(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  

 // Handle input change
const handleChange = (e, name) => {
  const { value } = e.target;
  setFormDataA((prev) => ({ ...prev, [name]: value }));
};

  const [Amenity,setAmenity] = useState([])

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleAmenity/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setAmenity(res.data.data.value);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const [selectedCategory, setSelectedCategory] = useState(""); // Track selected main category
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1)
          setallSubCategory(res1.data.data);
        }

        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewCategory`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2)
          setallCategory(res2.data.data);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    }
    fetchData();
  }, [config.base_url, count]);

  

  const [allShips, setallShips] = useState([]);
   
    
  
  
    // fetch ship data
    useEffect(() => {
      async function fetchdata() {
        try {
          const res1 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              
            }
          );
          if (res1.data.status === 200) {
            console.log(res1);
            setallShips(res1.data.data);
          } else {
            console.log("error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchdata();
    }, [config.base_url,  count]);
const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShips.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShips.length));
};


  const [allImages,setAllImages] = useState([])
  const [newImages, setNewImages] = useState([]);

  const [mainImages, setMainImages] = useState([]); // Array to store multiple images
  
  useEffect(() => {
    async function fetchShipImages() {
      try {
        const response = await axios.get(`${config.base_url}/api/HappyMarineShipping/singleShipImageCReg/${id}`);
        if (response.data.status === 200 && response.data.data.length > 0) {
          const mainImagesData = response.data.data.filter(img => img.image !== null);
          setMainImages(mainImagesData);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    }
  
    fetchShipImages();
  }, [id]);
  

  const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
  
  

  // Filter subcategories when main category changes
  useEffect(() => {
    if (selectedCategory) {
      const filtered = allSubCategory.filter(
        (sub) => Number(sub.category) === Number(selectedCategory) // Convert both to numbers
      );
      setFilteredSubCategories(filtered);
    } else {
      setFilteredSubCategories([]);
    }
  }, [selectedCategory, allSubCategory]);


   const [generatedCode, setGeneratedCode] = useState("");
const [codeCounter, setCodeCounter] = useState("");


  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");

const subCategoryPrefixes = {
  barge: "BRG",
  bulk: "BLK",
  cargo: "CRG",
  container: "CNT",
  fishing: "FIS",
  multipurpose: "MPP",
  passengerferry: "PAX",
  reefer: "REF",
  roro: "ROR",
  tanker: "TNK",
  tugboat: "TUG",
  dredger: "DRG",
  floatingcrane: "FLC",
  landingcraft: "LCT",
  yacht: "YCT",
  supplyboat: "SUB",
  crewboat: "CRB",
  floatingdock: "FLD",
  others: "OTR"
};

useEffect(() => { 
  if (vesselType) {
    const normalized = normalize(vesselType);
    const prefix = subCategoryPrefixes[normalized];
    if (prefix) {
      setGeneratedCode(prefix); // ✅ Only set the prefix
    } else {
      setGeneratedCode("");
    }
  }
}, [vesselType]);


  const handleDeleteImage = async (key, isNew) => {
  if (isNew) {
    // Remove new image
    setNewImages((prev) => prev.filter((_, idx) => `new-${idx}` !== key));
  } else {
    try {
      const idToDelete = parseInt(key); // Ensure numeric ID
      const response = await axios.delete(`${config.base_url}/api/HappyMarineShipping/deleteCharterImage/${idToDelete}`);
      
      if (response.data.status === 200) {
        setMainImages((prev) => prev.filter((img) => img.id !== idToDelete));
        toast.success("Image deleted", { autoClose: 1500 });
      } else {
        toast.error("Image not found", { autoClose: 1500 });
      }
    } catch (error) {
      console.log("Error deleting image:", error);
      toast.error("Error deleting image", { autoClose: 2000, position: "top-right" });
    }
  }
};


  const cleanInput = (input) => {
    return input.replace(/[\u200B-\u200D\uFEFF]/g, "");  // Remove Zero-width characters and BOM
  };
  

   const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
  
    const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setNewImages((prev) => [...prev, ...files]);
    e.target.value = null; // clear the input so you can re-upload the same file if needed
  };
  
    const removeImage = (index) => {
      const updatedImages = [...selectedImages];
      updatedImages.splice(index, 1);
      setSelectedImages(updatedImages);
    };
  
const [dropdownOpen, setDropdownOpen] = useState(false);
    const [activeRegion, setActiveRegion] = useState(null);  // clicked region
      const [hoveredRegion, setHoveredRegion] = useState(null); // hovered region
     const [selectedRegion, setSelectedRegion] = useState(null);
          const [selectedCountry, setSelectedCountry] = useState(null);
          const token =localStorage.getItem('token')
      
            const [Lychan,setLychan] = useState('');
            const [TypeOfCargo,setTypeOfCargo] = useState('')
            const [Tonnage,setTonnage] = useState('')
            const [LoadingPort,setLoadingPort] = useState('')
            const [DischargePort,setDischargePort] = useState('')
            const [ChartererAcc,setChartererAcc] = useState('')
            const [Commission,setCommission] = useState('')
            const userId = localStorage.getItem("userId");
            

const [url,setUrl] = useState('')
            useEffect(() => {
  async function fetchShipData() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/singleLogistic/${id}`);
      if (res1.data.status === 200) {
        const shipAmenities = res1.data.data.amenities;
        setTypeOfCargo(res1.data.data.type_of_cargo)
        setTonnage(res1.data.data.tonnage)
        setLoadingPort(res1.data.data.loading_port)
        setDischargePort(res1.data.data.discharge_port)
        setLychan(res1.data.data.lychan)
        setChartererAcc(res1.data.data.charterer_account)
        setCommission(res1.data.data.commission)
        setEmail(res1.data.data.email)
        setMobileNO(res1.data.data.phone)
        setBriefDescription(res1.data.data.brief_description)
        setName(res1.data.data.name)
        setCompany(res1.data.data.company)
        setCompanyAddress(res1.data.data.company_address)
        setUrl(res1.data.data.url_new)
      


        const res2 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewAmenities`);
        if (res2.data.status === 200) {
          setAmenities(res2.data.data);
          mergeAmenities(shipAmenities, res2.data.data); // Merge ship data with input fields
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchShipData();
}, [config.base_url, id]);


  const [hoverCountry, setHoverCountry] = useState("");
  const [selectedPort, setSelectedPort] = useState("");
  const [countryQuery, setCountryQuery] = useState("");


  // ---- Countries with ports (sample; extend with your full list) ----
  const countriesWithPorts = {
    "Antigua": {
      flag: "",
      ports: ["St John’s"]
    },
    "Angola": {
      flag: "",
      ports: ["Cabinda", "Futila Terminal", "Lobito", "Luanda", "Mocamedes", "Namibe", "Porto Saco"]
    },
    "Algeria": {
      flag: "",
      ports: ["Algiers", "Annaba", "Arzew", "Arzew El-Djedid", "Bejala", "Bethioua", "Bone", "Mostaganem", "Oran", "Philippeville", "Port Methanier", "Skikda"]
    },
    "Albania": {
      flag: "",
      ports: ["Vlone", "Vlore"]
    },
    "Argentina": {
      flag: "",
      ports: ["Bahia Blanca", "Buenos Aires", "Caleta Cordova", "Caleta Olivares", "Caleta Olivia", "Campana", "Comodoro Rivadavia", "Diamante", "General Lagos", "Ibicuy", "Ingeniero Buitrango", "Ingeniero White", "La Plata", "Puerto Acevedo", "Puerto Belgrano", "Puerto Galvan", "Puerto Ingeniero Rocca", "Puerto Madryn", "Puerto Martins", "Puerto Parana", "Puerto Rosales", "Punta Alvear", "Punta Ancla", "Punta Ciguena", "Punta Loyola", "Ramallo", "Rio Gallegos", "Rosario", "San Lorenzo", "San Martin", "San Nicolas", "San Pedro", "San Sebastian Bay", "Santa Fe", "Villa Constitucion", "Zarate"]
    },
    "Ascension Island": {
      flag: "",
      ports: ["Clarence Bay", "English Bay", "Georgetown"]
    },
    "Aruba": {
      flag: "",
      ports: ["Barcadera", "Oranjestad", "San Nicolas"]
    },
    "Australia": {
      flag: "",
      ports: ["Abbot Point", "Adelaide", "Albany", "Ball’s Head", "Ballast Point", "Balmain", "Barney Point", "Barrow Island", "Beauty Point Harbour", "Bell Bay", "Berry’s Bay", "Blackwattle Bay", "Boston Bay", "Botany Bay", "Bowen", "Brisbane", "Bunbury", "Bundaberg", "Burnie", "Cairns", "Carnarvon", "Cooktown", "Cossack Pioneer Terminal", "Crib Point", "Dalrymple Bay", "Dampier", "Darling Harbour", "Darwin", "Devonport", "East Intercourse Island", "Eden", "Emu Bay", "Esperance", "Finucane Island", "Fisherman Islands", "Fremantle", "Geelong", "George Town", "Geraldton", "Gladstone", "Glebe Island", "Gore Bay", "Gove", "Groote Eylandt", "Hastings", "Hay Point", "Hobart", "Humbug Point", "Koolan Island", "Kurnell", "Kwinana", "Launceston", "Long Island Point", "Long Reach", "Lorim Point", "Mackay", "Macquarie Point", "Melbourne", "Miner Bay", "Mistaken Island", "Munganno Point", "Nelson Point", "Newcastle", "Parker Point", "Perth", "Pinkenba", "Port Alma", "Port Augusta", "Port Botany", "Port Hedland", "Port Jackson", "Port Kembla", "Port Kennedy", "Port Latta", "Port Lincoln", "Port Pirie", "Port Stanvac", "Port Walcott", "Porter Bay", "Portland", "Princess Royal Harbour", "Proper Bay", "Pyrmont", "Risdon", "Rockhampton", "Self’s Point", "Snail’s Bay", "Snug Cove", "Spalding Cove", "Stanley", "Sydney", "Sydney Cove", "Thursday Island", "Townsville", "Trial Bay", "Twofold Bay", "Urangan", "Wallaroo", "Weipa", "Western Port", "White Bay", "Whyalla", "Withnell Bay", "Wyndham", "Yampi Sound"]
    },
    "Bahamas": {
      flag: "",
      ports: ["Clifton Point", "Freeport", "Nassau"]
    },
    "Bahrain": {
      flag: "",
      ports: ["Mina Salman", "Sitra"]
    },
    "Bangladesh": {
      flag: "",
      ports: ["Chalna", "Chittagong", "Khulna", "Mongla"]
    },
    "Barbados": {
      flag: "",
      ports: ["Black Rock Tanker Terminal", "Bridgetown", "Needham’s Point Tanker Terminal", "Olistins Bay Tanker Terminal", "Spring Garden Tanker Terminal"]
    },
    "Belgium": {
      flag: "",
      ports: ["Antwerp", "Bruges", "Ghent", "Ostend", "Zeebrugge"]
    },
    "Belize": {
      flag: "",
      ports: ["Belize City"]
    },
    "Benin": {
      flag: "",
      ports: ["Cotonou"]
    },
    "Bermuda": {
      flag: "",
      ports: ["Freeport", "Hamilton"]
    },
    "Azores": {
      flag: "",
      ports: ["Horta", "Ponta Delgada"]
    },
    "Brazil": {
      flag: "",
      ports: ["Admiral Barroso Terminal", "Alemoa Terminal", "Antonina", "Aracaju", "Aratu", "Barao De Tefe", "Barnabe Island Terminal", "Belem", "Butadeine Dock Island", "Cabedelo", "Conceicaoziinha Terminal", "Cosipa Terminal", "Cutrale Terminal", "DTSE/GEGUA Oil Terminal", "Fortaleza", "Governor’s Island", "Ilha Redonda", "Itaqui", "Maceio", "Madre Deus", "Manaus", "Miramar Oil Terminal", "Mucuripe", "Natal", "Niteroi", "Paranagua", "Ponta da Madeira", "Porto Alegre", "Praia Mole", "Recife", "Redonda Island", "Rio de Janeiro", "Rio Grande", "Salvador", "Santos", "Sao Cristovao", "Sao Luis", "Sao Sebastiao", "Torgua", "Tramandai", "Tubarao", "Ultrafertil Terminal", "Vitoria"]
    },
    "Cameroon Republic": {
      flag: "",
      ports: ["Bonaberi", "Douala", "Limbe", "Limboh Terminal", "Victoria"]
    },
    "Bulgaria": {
      flag: "",
      ports: ["Bourgas", "Pomorie", "Sozopol", "Tzarevo", "Varna"]
    },
    "Brunei Darussalam": {
      flag: "",
      ports: ["Kuala Belait", "Seria"]
    },
    "Canada": {
      flag: "",
      ports: ["Argentia", "Baie Verte", "Baie-Comeau", "Bathurst", "Bayside", "Belledune", "Berrypoint", "Botwood", "Brooklyn", "Burlington Bay", "Campbell River", "Canaport", "Chandler", "Charlottetown", "Chatham", "Chicoutimi", "Churchill", "Clarenville", "Clarkson", "Come By Chance", "Comeau Bay", "Corner Brook", "Dalhousie", "Duke Point", "Duncan Bay", "Esquimalt", "Fairview Cove", "Frobisher", "Gold River", "Goose Bay", "Halifax", "Hamilton", "Havre St Pierre", "Holyrood", "Humbermouth", "Iqaluit", "Kingston", "Kingsville", "Kitimat", "Lewisporte", "Liverpool", "Long Harbour", "Matane", "McKellar Island", "Middle Point", "Mission River", "Mont Louis", "Montreal", "Mulgrave", "Nanaimo", "New Glasgow & Trenton", "New Richmond", "Newcastle", "North Sydney", "Ocean Falls", "Ogden Point", "Pictou", "Point Tupper", "Pointe Aux Basques", "Pointe Noire", "Port Alberni", "Port Alfred", "Port Alice", "Port aux Basques", "Port Cartier", "Port Harmon", "Port Hawkesbury", "Port Medway", "Port Saguenay", "Port Stanley", "Powell River", "Prince Rupert", "Quebec", "Ridley Island", "Rimouski", "Roberts Bank", "Saint John", "Sarnia", "Sept-Iles", "Seven Islands", "Shelburne", "Sorel", "St Andrews", "St John’s", "St Romuald", "Stephenville", "Stewart", "Sydney", "Tahsis", "Thunder Bay", "Toronto", "Trois-Rivieres", "Vancouver", "Victoria", "Whiffen Head", "Windsor", "Yarmouth"]
    },
    "Cayman Islands": {
      flag: "",
      ports: ["Georgetown"]
    },
    "Cape Verde Islands": {
      flag: "",
      ports: ["Mindelo", "Palmeira Bay", "Pedra De Lume", "Porto Grande", "Sal Island", "Santa Maria Bay"]
    },
    "Canary Islands": {
      flag: "",
      ports: ["Las Palmas", "Puerto Caballo Oil Terminal", "Puerto de la Hondura Oil Terminal", "Puerto de La Luz y Las Palmas", "Santa Cruz de Tenerife"]
    },
    "Chile": {
      flag: "",
      ports: ["Antofagasta", "Arica", "Barquito", "Cabo Negro", "Calbuco", "Caldera", "Caleta Clarencia", "Caleta Coloso", "Caleta Ossa", "ChanaraI", "Coquimbo", "Corrale", "Cutter Cove", "Gregorio", "Guacolda", "Guayacan", "Huasco", "Iquique", "La Chimba Cove", "Laredo", "Las Losas", "Las Salinas", "Lendaura", "Lirquen", "Pecket", "Porvenir", "Puerto Coralle", "Puerto Corral", "Puerto Montt", "Puerto Percy", "Puerto Ventanas", "Punta Arenas", "Quintero", "San Antonio", "San Gregorio", "San Vicente", "Santa Barbara", "Talcahuano", "Taltal", "Tocopilla", "Valdivia", "Valparaiso"]
    },
    "China": {
      flag: "",
      ports: ["Amoy", "Baoshan", "Bayuquan", "Beijang", "Canton", "Chefoo", "Chinwangtao", "Dagang", "Dairen", "Dalian", "Dayao Bay", "Dongdu", "Fuzhou", "Foochow", "Ganjingzi", "Guangzhou", "Handi", "Hankow", "Heizluzui", "Heshangdao", "Hong Kong", "Huangdao", "Huangpu", "Nanjing", "Nianyuwan", "Qianwan", "Qingdao", "Qinhuangdao", "Shanghai", "Shantou", "Siergou", "Swatow", "Taku Bar", "Tanggu", "Tianjin", "Tsamkong", "Tsingtao", "Wei Hai", "Wuhan", "Xiahai", "Xiamen", "Xianglujiao", "Xidi", "Xigang", "Xingang", "Xinshenwei", "Yantai", "Yingkou", "Zhanjiang","Gaolan Port"]
    },
    "Cocos Islands": {
      flag: "",
      ports: ["Port Refuge"]
    },
    "Christmas Island": {
      flag: "",
      ports: ["Christmas Island"]
    },
    "Colombia": {
      flag: "",
      ports: ["Barranquilla", "Buenaventura", "Cartagena", "Cienaga", "Covenas Offshore Terminal", "Ecopetrol", "Mamonal", "Monomeros", "Muelles El Bosque", "Pindo", "Pozos Colorados", "Puerto Prodeco", "Puerto Zuniga", "Santa Marta", "Tolu", "Tumaco"]
    },
    "Costa Rica": {
      flag: "",
      ports: ["Golfito", "Golfo Dulce", "Puerto Limon", "Puerto Moin", "Puntarenas", "Quepos"]
    },
    "Congo (Democratic Republic)": {
      flag: "",
      ports: ["Ango-Ango", "Banana", "Boma", "Matadi", "Moanda Oil Terminal"]
    },
    "Congo (Republic of Congo)": {
      flag: "",
      ports: ["Pointe-Noire"]
    },
    "Comoros": {
      flag: "",
      ports: ["Dzaoudzi", "Longoni", "Mamoudzou", "Mayotte", "Moroni", "Pamandzi Bay"]
    },
    "Croatia": {
      flag: "",
      ports: ["Bakar", "Dubrovnik", "Gazenica", "Krk Island", "Luka Gruz", "Omisalj", "Pula", "Rijeka", "Rijeka Dubrovačka", "Sepen", "Sibenik", "Split", "Srećica", "Susak", "Urinj", "Zadar"]
    },
    "Cuba": {
      flag: "",
      ports: ["Antilla", "Banes", "Caibarien", "Cardenas", "Casilda", "Cayo Frances", "Cienfuegos", "Felton", "Guantanamo", "Havana", "Macabi", "Manzanillo", "Mariel", "Matanzas", "Nuevitas", "Pastellilo", "Preston", "Puerto Padre", "Puerto Tarafa", "Santiago de Cuba", "Tarafa"]
    },
    "Cyprus": {
      flag: "",
      ports: ["Akrotiri", "Dhekelia", "Famagusta", "Gemikonagi", "Karavostassi", "Larnaca", "Limassol", "Moni", "Morphou Bay", "Paphos", "Vassiliko", "Xeros"]
    },
    "Denmark": {
      flag: "",
      ports: ["Aabenraa", "Aalborg", "Aarhus", "Asnaesvaerkets Havn", "Avernakke", "Copenhagen", "Ebeltoft", "Elsinore", "Ensted", "Esbjerg", "Fredericia", "Frederikshavn", "Frederikssund", "Gulfhavn", "Helsingor", "Horsens", "Kalundborg", "Karrebaeksminde", "Koge", "Kolding", "Korsoer", "Kyndby", "Lindholm", "Lindoe Terminal", "Lyngs Odde", "Masnedsvaerkets Havn", "Naestved", "Nyborg", "Odense", "Orehoevd", "Ronne", "Rudkobing", "Skaelskor", "Skaerbaek", "Skagen", "Stigsnaesvaerkets Havn", "Svendborg", "Tuborg", "Vordingborg"]
    },
    "Ecuador": {
      flag: "",
      ports: ["Andiport", "Balao Terminal", "Esmeraldas", "Guayaquil", "La Libertad", "Terpe Terminal"]
    },
    "Dominican Republic": {
      flag: "",
      ports: ["Barahona", "Cabo Rojo", "Ciudad Trujillo", "La Romana", "Manzanillo", "San Pedro de Macoris", "Sans Souci", "Santo Domingo"]
    },
    "Dominica": {
      flag: "",
      ports: ["Roseau", "Woodbridge Bay"]
    },
    "Djibouti": {
      flag: "",
      ports: ["Djibouti"]
    },
    "Egypt": {
      flag: "",
      ports: ["Abu Zenima", "Adabiya", "Alexandria", "Ataqa", "El Alamein", "El Dekheila", "El Meks", "Hurghada", "Kosseir", "Mersa el Hamra", "Port Ibrahim", "Port Said", "Port Tewfik", "Quseir", "Ras Budran", "Ras Gharib", "Ras Shukheir", "Ras Sudr", "Safaga", "Suez", "Wadi Feiran"]
    },
    "Fiji": {
      flag: "",
      ports: ["Lautoka", "Suva", "Walu Bay"]
    },
    "Faroe Islands": {
      flag: "",
      ports: ["Drelnes", "Fuglafjordur", "Klaksvik", "Kollafjordur", "Midvaag", "Runavik", "Skaala", "Soervaag", "Strendur", "Torshavn", "Trangisvaag", "Tvoroyri", "Vagu", "Vestmanna"]
    },
    "Falkland Islands": {
      flag: "",
      ports: ["Port Stanley", "Stanley"]
    },
    "Estonia": {
      flag: "",
      ports: ["Kesklinna", "Kopli-Port Of Tallinn", "Muuga-Port Of Tallinn", "Novotalinsky", "Old City Harbour-Port of Tallinn", "Paldiski-Port Of Tallinn", "Paljassaare", "Tallinn"]
    },
    "Eritrea": {
      flag: "",
      ports: ["Assab", "Massawa"]
    },
    "Equatorial Guinea": {
      flag: "",
      ports: ["Malabo", "Punta Europa Terminal", "Rey Malabo"]
    },
    "El Salvador": {
      flag: "",
      ports: ["Acajutla", "Acajutla Offshore Terminal", "Cutuco", "La Union"]
    },
    "Finland": {
      flag: "",
      ports: ["Abo", "Ajos", "Haakoninlahti", "Hamina", "Hanko", "Haponniemi", "Helsinki", "Hepokari", "Inkoo", "Jakobstad", "Kemi", "Kokkola", "Kotka", "Kristinestad", "Laajasalo Oil Harbour", "Loviisa", "Mantyluoto", "Naantali", "Nuottasaari", "Oritkari", "Oulu", "Pansio", "Pateniemi", "Pietarsaari", "Pori", "Porvoo", "Rauma", "Reposaari", "Tolkkinen-Tolkis", "Toppila", "Turku", "Uusikaupunki", "Veitsiluoto", "Vihreasaari", "Vuosaari Harbour", "Ykspihlaja"]
    },
    "France": {
      flag: "",
      ports: ["Ajaccio", "Ambes", "Antibes", "Antifer", "Basse Indre", "Bassens", "Bastia", "Bayonne", "Bec d’ Ambes", "Blaye", "Bordeaux", "Boulogne-sur-Mer", "Brest", "Caen", "Calais", "Cannes", "Caronte", "Cherbourg", "Cordemais", "Corniguel", "Coueron", "Dieppe", "Donges", "Dunkirk", "Etang de Berre", "Fos", "Gravenchon", "Haut Indre", "Honfleur", "Indret", "La Ciotat", "La Mede", "La Nouvelle", "La Pallice", "La Pointe de Berre", "La Rochelle", "La Rochelle-Pallice", "La Seyne-Bregaillon", "Lavera", "Le Havre", "Le Verdon", "Lorient", "Marseilles", "Montoir", "Nantes-St Nazaire", "Nice", "Paimboeuf", "Pauillac", "Petit Couronne", "Port de Bouc", "Port Jerome", "Port St Louis du Rhone", "Port St Nicholas", "Port Toga", "Port Tudy", "Quimper-Corniguel", "Rouen", "Sete", "St Malo", "St Nazaire", "Toulon La Seyne", "Villefranche"]
    },
    "Georgia": {
      flag: "",
      ports: ["Batumi", "Poti"]
    },
    "Gambia": {
      flag: "",
      ports: ["Banjul"]
    },
    "Gabon": {
      flag: "",
      ports: ["Gamba", "Libreville", "Ovendo", "Owendo", "Port Gentil"]
    },
    "French Polynesia": {
      flag: "",
      ports: ["Papeete"]
    },
    "Germany": {
      flag: "",
      ports: ["Blexen", "Brake", "Bremen", "Bremerhaven", "Brunsbuttel", "Butzfleth", "Cuxhaven", "Elbeharbour", "Elsfleth", "Emden", "Flensburg", "Hamburg", "Holtenau", "Kiel", "Kiel-Holtenau", "Laboe", "Lubeck", "Nordenham", "Ostermoor", "Rostock"]
    },
    "Gibraltar": { flag: "", ports: ["Gibraltar"] },
  "Ghana": { flag: "", ports: ["Takoradi", "Tema"] },
  "Greece": { flag: "", ports: [
    "Acandia","Adamas","Aghios Nikolaos","Agia Marina","Agia Trias","Agioi Theodoroi","Argostoli",
    "Aspraspitia Ore Terminal","Aspropyrgos","Ayia Marina","Ayios Nikolaos","Canea","Cephalonia",
    "Corfu (Kerikra)","Corinth","Corinth Canal","Drapetsona Bay","Elefsis","Eleusis","Foron Bay",
    "Gera Bay","Hercules Port","Iraklion","Isthmia","Kalamaki","Kalamata","Kali Limenes","Kavala",
    "Kithira","Kos","Lamia","Leros Island","Lixouri","Malagari","Mandraki","Mandukio","Marathocampos",
    "Megara Oil Terminal","Microlimano","Milos Island","Mitilene","Nafplion","Nauplia","Pachi","Pamfila",
    "Paroikia","Paros","Patras","Perama","Phaleron Bay","Piraeus","Poseidonia","Prinos","Pylos",
    "Pythagorio","Rhodes","Rion","Salonica","Samos","Skaramanga","Souda Bay","St George Harbour",
    "Stylis","Suda Bay","Syros Island","Thessaloniki","Volos","Voudhia Bay","Zakinthos","Zante","Zea"
  ]},
  "Guyana": { flag: "", ports: ["Georgetown"] },
  "Guinea-Bissau": { flag: "", ports: ["Bissau"] },
  "Guinea": { flag: "", ports: ["Conakry","Kamsar"] },
  "Guatemala": { flag: "", ports: ["Puerto Barrios","Puerto Quetzal","San Jose","Santo Tomas de Castilla"] },
  "Guam": { flag: "", ports: ["Apra Harbour"] },
  "Guadeloupe": { flag: "", ports: ["Pointe-a-Pitre"] },
  "Grenada": { flag: "", ports: ["Grand Mal Tanker Terminal","Queen’s Park Tanker Terminal","St George’s"] },
  "Greenland": { flag: "", ports: [
    "Faeringehavn","Godthaab","Grønnedal","Ivigtut","Kangerlussuaq","Kangilinnguit",
    "Narsarsuaq","Nuuk","Qaanaaq","Soendre Strømfjord"
  ]},
  "Honduras": { flag: "", ports: ["La Ceiba","Tela"] },
  "Haiti": { flag: "", ports: ["Port au Prince"] },
  "Hong Kong": { flag: "", ports: [
    "Chai Wan","Hong Kong","Kowloon","Kwai Chung","Kwun Tong","Lamma Island","Stonecutters Island",
    "Tap Shek Kok","Tsing Yi Island","Tsuen Wan","Tuen Mun","Wan Chai","Yau Ma Tei"
  ]},
  "Iceland": { flag: "", ports: [
    "Grundartangi","Hafnarfjordur","Keflavik - Njarovik","Njarovik","Reykjavik","Seydisfjordur","Straumsvik"
  ]},
  "India": { flag: "", ports: [
    "Beypore","Bheemunipatnam","Bombay","Budge Budge","Calcutta","Calicut","Cannanore","Chennai","Cochin",
    "Jawahar Dweep","Kakinada","Kandla, Gujarat","Kochi","Kolkata","Madras","Mangalore","Mormugao","Mumbai","Mundra",
    "New Mangalore","Okha","Panaji","Pir Pau","Pondicherry","Port Blair","Port Okha","Tellicherry",
    "Visakhapatnam","Vizag"
  ]},
  "Indonesia": { flag: "", ports: [
    "Ambon","Ampeanam","Balikpapan","Batu Ampar","Belawan","Bengkulu","Benoa","Biak","Buatan","Bunyu","Cigading",
    "Cilacap","Cirebon","Citra Ujung Baru","Dumai","Gabion","Gresik","Jakarta","Jambi","Kabil","Kalianget",
    "Kota Baru","Kupang","Labuantring","Lembar","Macassar","Makassar","Manado","Medan","Muntok",
    "North Pulau Laut Coal Terminal","Palembang","Pangkalan Susu","Panjang","Pare Pare","Pekanbaru","Plaju & Sungai Gerong",
    "Pontianak","Pulau Laut","Pulau Sambu","Sabang","Samarinda","Sekupang","Semarang","Sibolga","Sorong",
    "Sunda Kelapa","Sungai Gerong","Sungai Pakning","Surabaya","Tanjung Emas","Tanjung Intan","Tanjung Pandan",
    "Tanjung Perak","Tanjung Priok","Tanjung Uban","Tarahan Terminal","Tarakan Island","Telok Ayer","Teluk Bayur","Ujung Pandang"
  ]},
  "Iran": { flag: "", ports: [
    "Abadan","Bahregan","Bahregan Oil Centre (BOC)","Bahrgan","Bandar Abbas","Bandar Imam Khomeini",
    "Bandar Mahshahr","Bandar Shahid Bahonar","Bandar Shahid Rejaie","Barkan","Bushehr","Bushire",
    "Cyrus Terminal","Kharg Island","Khemco Terminal","Lavan Island","Shahid Bahonar","Shahid Rajai","Soroosh Terminal"
  ]},
  "Iraq": { flag: "", ports: [
    "Abu Al Kashib","Abu Flus","Ashar","Basrah","Fao","Khor Al Amaya","Khor Al Zubair","Maqal","Sunger"
  ]},
  "Ireland": { flag: "", ports: [
    "Aughinish","Bantry","Castletown Bere","Cobh","Cork","Dinish Island","Drogheda","Dublin","Dun Laoghaire","Duncannon",
    "Foynes","Galway","Haulbowline","Howth","Kilrush","Leahlill Quarry","Limerick","Moneypoint","Rathmullen","Ringaskiddy",
    "Rosslare Europort","Rushbrooke","Shannon Foynes Port","Sligo","Tarbert Island","Waterford","Whiddy Island","Whitegate"
  ]},
  "Israel": { flag: "", ports: ["Ashdod","Ashkelon","Eilat","Haifa","Kishon Zone"] },
  "Isle of Man": { flag: "", ports: ["Douglas"] },
  "Italy": { flag: "", ports: [
    "Ancona","Arbatax","Assemini","Augusta","Bagnoli","Bala","Bari","Brindisi","Cagliari","Castellammare di Stabia",
    "Catania","Civitavecchia","Crotone","Falconara","Fiumicino","Formia","Gaeta","Gela","Genoa",
    "La Maddalena (Cagliari)","La Maddalena (Sardinia)","La Spezia","Leghorn","Livorno","Melilli Oil Terminal","Messina",
    "Milazzo","Monfalcone","Monopoli","Naples","Ortona","Otranto","Palau","Palermo","Portici","Porto Corsini",
    "Porto di Malamocco","Porto Empedocle","Porto Foxi","Porto Marghera","Porto Marmoreo","Porto San Leonardo","Porto Santo Stefano",
    "Porto Torres","Pozzuoli","Priolo","Priolo Gargallo","Punto Franco","Quiliano Terminal","Ravenna","Reggio Calabria",
    "San Vitale","Santa Panagia Bay","Sarroch","Savona-Vado","Siracusa","Talamone","Taranto","Termini Imerese",
    "Torre Annunziata","Torre del Greco","Trapani","Trieste","Vado Ligure","Venice"
  ]},
  "Jamaica": { flag: "", ports: ["Kingston","Port Bustamente","Port Esquivel","Port Royal","Salt River"] },
  "Ivory Coast": { flag: "", ports: [
    "Abidjan","Banco Bay","Canal de Virdi","Locodjo","Port Bouet Tanker Terminal"
  ]},
  "Japan": { flag: "", ports: [
    "Aboshi","Aburakawa","Aioi","Amagasaki","Aomori","Chiba","Chita","Etajima","Fukuyama","Funakawa","Hakata","Hakodate",
    "Hamada","Hannan","Hashihama","Heianza","Hibikinada","Higashi-Harima","Higashi-Ogishima","Hikari","Hikoshima","Himeji",
    "Hiro","Hirohata","Hiroshima","Iho","Imabari","Imari","Ishikara","Iwakuni","Izumisano","Kagoshima","Kainan","Kakogawa",
    "Kanmon Ko","Kanokawa","Karita","Kashima","Kawasaki","Keihin","Kikuma","Kinwan","Kishiwada","Kitakyushu","Kobe","Kokura",
    "Kudamatsu","Kure","Kushiro","Marugame","Mategata","Matsuyama","Mega","Miike","Mitsukojima","Mizushima","Moji","Muroran",
    "Nagasaki","Nagoya","Naha","Namikata","Niigata-Higashi","Niigata-Nishi","Nishihara","Ofunato","Ogishima","Oita","Omishima",
    "Onoda","Osaka","Owase","Rokko Island","Sakai","Sakaide","Sakaiminato","Sasebo","Senboku","Shikama","Shimizu","Shimonoseki",
    "Shimotsu","Shirashima","Susaki","Takasago","Takehara","Tamashima","Tobata","Tokai","Tokuyama","Tonda","Tokyo","Toyama",
    "Toyama-Shinko","Tsuruga","Ube","Ukishima","Wakamatsu","Wakayama","Yawata","Yokkaichi","Yokohama","Yokosuka"
  ]},
  "Kenya": { flag: "", ports: [
    "Kilindi","Kipevu Oil Terminal","Mbaraki","Mombasa","Port Reitz","Port Tudor","Shimanzi Oil Terminal"
  ]},
  "Jordan": { flag: "", ports: ["Aqaba","Mo’ta","Mushterak"] },
  "Kiribati": { flag: "", ports: ["Banaba"] },
  "North Korea": { flag: "", ports: ["Hungnam"] },
  "South Korea": { flag: "", ports: ["Busan","Inchon","Pohang","Pusan","Samil","Yeosu","Yosu"] },
  "Kuwait": { flag: "", ports: ["Mina Abdulla","Mina Al Ahmadi","Mina Al Zour","Mina Saud","Shuaiba","Shuwaikh"] },
  "Latvia": { flag: "", ports: ["Lielupe","Liepaja","Riga","Ventspils"] },
  "Lebanon": { flag: "", ports: ["Beirut","Dora Terminal","Saida","Sidon","Tripoli","Zahrani Terminal"] },
  "Liberia": { flag: "", ports: ["Buchanan","Monrovia"] },
  "Libya": { flag: "", ports: [
    "Benghazi","Es Sider","Marsa al Hariga","Marsa El Brega","Ras Lanuf","Rasco Harbour","Sirtica Terminal","Tarabulus",
    "Tobruk","Tripoli","Zueitina"
  ]},
  "Madeira": { flag: "", ports: ["Funchal","Praia Formosa"] },
  "Madagascar": { flag: "", ports: [
    "Andoany","Antalaha","Antsiranana","Diego Suarez","Fort Dauphin","Mahajanga","Majunga","Manakara","Mananjary","Morondava",
    "Nosy Be","Tamatave","Toamasina","Tolanaro","Tulear"
  ]},
  "Lithuania": { flag: "", ports: ["Klaipeda"] },
  "Malaysia": { flag: "", ports: [
    "Biawak","Butterworth","Datuk Sim Kheng Hong","Johor","Kota Kinabalu","Kuala Baram","Kuching","Labuan","Lutong","Malacca",
    "Miri","Pasir Gudang","Penang","Pending","Port Dickson","Port Kelang","Port Swettenham","Prai","Sandakan","Sejingkat","Senari",
    "Sibu","Sungai Udang","Tanah Puteh","Tanjung Bruas","Tanjung Manis","Tawau","Teluk Anson","Westport"
  ]},
  "Mauritius": { flag: "", ports: ["Port Louis"] },
  "Mauritania": { flag: "", ports: ["Nouadhibou","Nouakchott","Point Central","Port de L'Amitie","Port Eltenne"] },
  "Martinique": { flag: "", ports: ["Fort-de-France"] },
  "Malta": { flag: "", ports: ["Marsaxlokk","Valletta"] },
  "Mexico": { flag: "", ports: [
    "Cedros Island","Coatzacoalcos","Ensenada","Guaymas","Manzanillo","Mazatlan","Minatitlan","Morro Redondo","Nanchital",
    "Pajaritos","Rosarito Terminal","Salina Cruz","San Pedrito Port","Tampico","Tuxpan","Veracruz"
  ]},
  "Myanmar": { flag: "", ports: ["Akyab","Bassein","Moulmein","Mawlamyine","Pathein","Rangoon","Sittwe","Yangon"] },
  "Mozambique": { flag: "", ports: ["Beira","Maputo","Matola","Mozambique Island","Nacala","Pemba","Quelimane"] },
  "Morocco": { flag: "", ports: [
    "Agadir","Al Hoceima","Casablanca","Kenitra","Mohammedia","Port de Fedala","Port Nador","Safi","Tangier"
  ]},
  "Monaco": { flag: "", ports: ["Monaco"] },
  "Micronesia": { flag: "", ports: ["Tomil Harbour","Yap Colonia International Port"] },
  "Nauru": { flag: "", ports: ["Nauru"] },
  "Namibia": { flag: "", ports: ["Walvis Bay"] },
  "Netherlands": { flag: "", ports: [
    "Amsterdam","Axel Plain","Beverwijk","Botlek","Braakman Harbour","Delfzijl","Den Helder","Dordrecht","Europoort","Flushing",
    "Hansweert","Hoek van Holland","Hook of Holland","IJmuiden","Maassluis","Maasvlakte","Middelburg","Moerdijk","Pernis",
    "Port Scaldia","Rotterdam","Rozenburg","Sas Van Gent","Schiedam","Terneuzen","Velsen","Vlaardingen","Vlissingen","Ymuiden",
    "Zaandam","Zaanstad"
  ]},
  "New Caledonia": { flag: "", ports: ["Baie de Numbo","Baie des Dames","Kouaoua","Noumea","Poro","Thio"] },
  "Netherlands Antilles": { flag: "", ports: [
    "Bullen Bay","Caracas Bay","Emmastad","Santa Anna Bay","Schottegat","Sint Michielsbay","St Michel’s Bay","Willemstad"
  ]},
  "New Zealand": { flag: "", ports: [
    "Auckland","Bluff","Christchurch","Dunedin","Eastland Port","Gisborne","Lyttelton","Marsden Point","Napier","Nelson",
    "New Plymouth","Otago Harbour","Picton","Port Chalmers","Port Marlborough","Port Taranaki","Ravensbourne","Tauranga",
    "Timaru","Wanganui","Wellington","Whangarei"
  ]},
  "Nigeria": { flag: "", ports: [
    "Apapa","Bonny Inshore Terminal","Calabar","Dawes Island","Dockyard Creek","Escravos Oil Terminal","Forcados Oil Terminal","Ibeto",
    "Lagos","Okrika","Pennington","Port Harcourt","Qua Iboe"
  ]},
  "Nicaragua": { flag: "", ports: ["Corinto","Puerto Sandino"] },
  "Norway": { flag: "", ports: [
    "Aalesund","Aker Base","Ardalstangen","Arendal","Bergen","Bodo","Borg Havn IKS","Breivik","Brevik","Drammen","Egersund",
    "Fagerstrand","Fiborgtangen","Fredrikstad","Gismervoy","Grenland Harbour","Grimstad","Haavik","Halden","Hammerfest","Harstad",
    "Haugesund","Heroya","Holmen","Homsvik","Honningsvag","Horten","Hoyanger","Husnes","Kambo","Kirkenes","Kleven","Kristiansand",
    "Kristiansund","Langesund","Larvik","Mandal","Melios Harbour","Mjaanesholmen","Mo I Rana","Moss","Naersnes","Narvik",
    "Orkanger","Oslo","Porsgrunn","Prostneset","Rafnes","Risavika","Sandefjord","Sandnes","Sarpsborg","Sjursoya","Skien","Skogn",
    "Slagen","Sola","Stavanger","Svartnes","Svelvik","Svolvaer","Tananger","Tangen","Thamshavn","Tonsberg","Tromsdalen","Tromso",
    "Trondheim","Vardo"
  ]},
  "Papua New Guinea": { flag: "", ports: ["Lae","Lorengau","Madang","Port Moresby","Rabaul"] },
  "Panama": { flag: "", ports: [
    "Almirante","Bahia Las Minas","Balboa","Coco Solo North","Colon","Cristobal","Las Minas Bay","Manzanillo International Terminal",
    "Rodman Naval Station"
  ]},
  "Pakistan": { flag: "", ports: ["Juna Bunder","Karachi"] },
  "Oman": { flag: "", ports: ["Mina al Fahal","Muscat","Port Sultan Qaboos"] },
  "Peru": { flag: "", ports: [
    "Cabo Blanco","Callao","Chimbote","Coishco","General San Martín","Ilo","La Pampilla","Lobitos","Matarani","Mollendo","Pacasmayo",
    "Paramonga","Pimentel","Pisco","Salaverry","San Nicolas","Supe","Talara"
  ]},
  "Philippines": { flag: "", ports: [
    "Bais","Bataan","Batangas","Cebu","Culasi","Davao","Dumaguit","Estancia","Hondagua","Iloilo","Jolo","Jordan","Lamao","Legaspi",
    "Limay","Lucanin","Manila","Mariveles","Masbate","Mati","Olongapo","Poro Point","Roxas City","San Fernando","San Jose","Sangi",
    "Santa Ana","Sasa","Subic Bay","Toledo (Philippines)","Villanueva","Zamboanga"
  ]},
  "Puerto Rico": { flag: "", ports: [
    "Guanica","Guayanilla","Las Mareas","Mayaguez","Ponce","Porto Nuevo","San Juan","Tallaboa"
  ]},
  "Portugal": { flag: "", ports: ["Douro","Faro & Olhao","Leixoes","Lisbon","Oporto","Santa Apolonia","Setubal"] },
  "Poland": { flag: "", ports: ["Gdansk","Gdynia","Port Polnocny","Swinoujscie","Szczecin"] },
  "Qatar": { flag: "", ports: ["Doha","Halul Island","Mesaieed","Umm Said"] },
  "Romania": { flag: "", ports: ["Constantza","Galatz"] },
  "Reunion": { flag: "", ports: ["Pointe des Galets"] },
  "Russia": { flag: "", ports: [
    "Archangel","Bakaritsa","Ekonomiya","Kaliningrad","Kandalaksha","Leningrad","Leviy Bereg","Lomonosov","Murmansk",
    "Novorossiysk","Sheskharis","St Petersburg","Taganrog","Tuapse","Vladivostok","Vyborg","Yelsk","Yeysk"
  ]},
  "South Africa": { flag: "", ports: [
    "Cape Town","Durban","East London","Mossel Bay","Port Elizabeth","Port Natal","Saldanha Bay","Simonstown"
  ]},
  "Somalia": { flag: "", ports: ["Berbera","Chisimalo","Kismayu","Mogadiscio"] },
  "Solomon Islands": { flag: "", ports: ["Honiara","Point Cruz"] },
  "Slovenia": { flag: "", ports: ["Izola","Koper","Piran"] },
  "Singapore": { flag: "", ports: [
    "Brani Terminal","Jurong","Keppel","Pasir Panjang","Pulau Ayer Chawan","Pulau Bukom","Pulau Merlimau","Pulau Pesek",
    "Pulau Sebarok","Sembawang","Singapore","Tanjong Pagar"
  ]},
  "Sierra Leone": { flag: "", ports: ["Freetown","Kissy Oil Terminal","Pepel"] },
  "Seychelles": { flag: "", ports: ["Mahe","Port Victoria"] },
  "Serbia & Montenegro": { flag: "", ports: ["Bar","Kotor","Lipci"] },
  "Senegal": { flag: "", ports: ["Dakar","M’Bao Oil Terminal"] },
  "Saudi Arabia": { flag: "", ports: ["Jeddah","Ju’aymah Crude & LPG Terminals","Ras al Khafji","Ras Tanura","Yanbu"] },
  "São Tomé and Príncipe": { flag: "", ports: ["Santo Antonio","Sao Tome"] },
  "Samoa": { flag: "", ports: ["Apia"] },
  "Spain": { flag: "", ports: [
    "Abra","Algeciras","Alicante","Almeria","Aviles","Barcelona","Bilbao","Burriana","Cadiz","Cala Figuera","Cartagena","Castellon",
    "Castro-Urdiales","Ceuta","Corcubion","Corunna (La Coruña)","Escombreras","Ferrol","Gijon","Huelva","La Coruna","Mahon","Malaga",
    "Melilla","Palma","Pasajes","Puerto De Santa Maria","Puerto Real","Puerto Santa Maria","Punta Ceballos Tanker Terminal",
    "Punta Lucero Tanker Terminal","Raos","Rota","San Esteban de Pravia","San Sebastian","Santander","Santurce","Seville","Tarragona",
    "Torrevieja","Valencia","Vigo","Zorroza"
  ]},
  "Suriname": { flag: "", ports: ["Paramaribo"] },
  "Sudan": { flag: "", ports: ["Marsa Bashayer Export Terminal","Port Sudan","Suakin"] },
  "St. Vincent": { flag: "", ports: ["Arnos Vale","Campden Park Bay","Kingstown"] },
  "St. Lucia": { flag: "", ports: ["Castries","Cul-de-Sac","Pointe Seraphine"] },
  "St. Kitts & Nevis": { flag: "", ports: ["Basseterre"] },
  "St. Helena Island": { flag: "", ports: ["Jamestown"] },
  "Sri Lanka": { flag: "", ports: ["China Bay","Cod Bay","Colombo","Galle","Malay Cove","Trincomalee"] },
  "Sweden": { flag: "", ports: [
    "Ahus","Ala","Axelsvik Oil Terminal","Bado","Bollsta","Braviken","Brofjorden","Bulkhamnen","Djuro","Domsjo","Donso","Edstrandsbassangen",
    "Fredriksskans","Frihamnen","Froland","Gastgivarehagen","Gavle","Geffe","Goteborg","Gothenburg","Granudden","Hallstavik","Halmstad",
    "Hammarbyhamnen","Hargshamn","Harnosand","Helsingborg","Hudiksvall","Husum","Kage","Kalix","Kalmar","Karlsborg","Karlshall","Karlshamn",
    "Karlskrona","Karlstad","Karlsvik","Karskar","Kolo Harbour","Kubikenborg","Landskrona","Langror","Limhamn","Lomma","Loudden","Lugnvik",
    "Lulea","Lysekil","Malmo","Marstrand","Norrkoping","Nyhamn","Nykoping","Nynashamn","Ohmans","Ornskoldsvik","Orrskar","Ortviken","Oskarshamn",
    "Ostrand","Oxelosund","Oxhaga Harbour","Pampus Harbour","Paskallavik","Pitea","Ramshall","Ronneby","Ronnskar","Rya Harbour","Sandarne",
    "Skelleftea","Skeppsbron","Skoghall","Skredsvik","Skutskar","Slite","Soderhamn","Sodertalje & Sodertalje Canal","Solvesborg","Soraker",
    "Stadsgarden","Stenungsund","Stilleryd Harbour","Stockholm","Stockvik","Stormskar Oil Terminal","Stroemstad","Stugsund","Sundsvall",
    "Sutudden Harbour","Tallbacken","Trelleborg","Tunadalshamnen","Uddebo","Uddevalla","Umea","Utansjo","Vaja","Vallvik","Varberg","Vartahamnen",
    "Vasteras","Vastervik","Wallhamn"
  ]},
  "Syria": { flag: "", ports: ["Banias","Latakia","Tartous"] },
  "Tunisia": { flag: "", ports: ["Bizerte","Gabes","La Goulette","La Skhirra","Rades","Sfax","Tunis"] },
  "Trinidad & Tobago": { flag: "", ports: ["Brighton","Point Fortin","Port of Spain","Tembladora"] },
  "Togo": { flag: "", ports: ["Kpeme","Lome"] },
  "Thailand": { flag: "", ports: [
    "Bang Hua Sua","Bangkok","Chognonsri Marine Terminal","Klong Toey","Koh Si Chang Transhipment Area","Kohsichang TPP","Krung Thep",
    "Laem Chabang","Phuket","Sathupradit","Sattahip","Sima Seaport","Sriracha Harbour","Sriracha Oil Terminals"
  ]},
  "Tanzania": { flag: "", ports: ["Dar es Salaam","Mjimwema Oil Terminal","Mtwara","Tanga","Zanzibar City"] },
  "Taiwan": { flag: "", ports: [
    "Kaohsiung","Keelung","Sha Lung Oil Terminal","Ta-Lin-Pu Offshore Oil Terminal","Tanshui","Yun-An LNG Terminal"
  ]},
  "Turkiye": { flag: "", ports: [
    "Ambarli","Bandirma","Bodrum","Borusan","Canakkale","Derince","Edincik","Fethiye","Gemlik","Haydarpasa","Isdemir","Iskenderun","Istanbul",
    "Izmir","Izmit","Karakoy","Marmaris","Mersin","Nemrut/Aliaga","Pirs Ekindzhiler","Samsun","Sinop","Tutuncifilik","Yarımca"
  ]},
  "United Arab Emirates": { flag: "", ports: [
    "Ajman","Das Island","Dubai","Fateh Terminal","Jabal Ali","Port Khalid","Port Rashid","Fujairah","Sharjah"
  ]},
  "Ukraine": { flag: "", ports: [
    "Azovstal","Feodosia","Illyichevsk","Kerch","Kherson","Mariupol","Odessa","Reni","Sevastopol","Theodosia","Zhdanov"
  ]},
  "United Kingdom": { flag: "", ports: [
    "Aberdeen","Appledore","Arbroath","Ardrossan","Avonmouth","Ayr","Ballylumford","Barrow-in-Furness","Barry","Barton","Belfast","Bideford",
    "Bird Port","Birkenhead","Blyth","Bowling","Braefoot Bay","Brightlingsea","Bristol","Brixham","Brodick Harbour","Bromborough","Burntisland",
    "Burray","Cairnryan","Campbeltown","Canvey Island","Cardiff","Cattawater Harbour","Charlestown","Chatham Docks","Colchester","Coolkeragh",
    "Coryton","Cowes","Cromarty Firth","Dagenham","Dartmouth","Dover","Dover Strait","Dundee","Dunoon","Eastham","Eccles","Ellesmere Port",
    "Falmouth","Fawley","Felixstowe","Fingringhoe","Finnart","Fishguard","Flotta Terminal","Folkestone","Forth Ports","Fowey","Garston","Glasgow",
    "Gourock","Grangemouth","Granton","Gravesend","Grays","Great Yarmouth","Greenock","Greenwich","Grimsby","Hamble","Hartlepool","Harwich",
    "Heysham","Holm","Holyhead","Hound Point","Howden","Howdendyke","Hull","Immingham","Ince","Invergordon","Inverness","Ipswich","Irlam","Irvine",
    "Isle Of Grain","Killingholme","King’s Lynn","Kingsnorth","Kirkcaldy","Kirkwall","Lamlash Harbour","Lancaster","Largs","Larne","Leith","Lerwick",
    "Lisahally Port","Liverpool","London","Londonderry","Longhope","Lowestoft","Lydney","Lyness","Manchester","Manchester Ship Canal","Maydown",
    "Medway Ports","Methil","Middlesbrough","Milford Docks","Milford Haven","Mistley","Montrose","Neath","New Holland","Newcastle upon Tyne",
    "Newhaven","Newlyn","Nigg Oil Terminal","North Woolwich","Oakham Ness","Oban","Old Kilpatrick","Otterham","Par","Partington","Pembroke","Penryn",
    "Penzance","Peterhead Bay Harbour","Peterhead Harbours","Plymouth","Poole","Port Henry","Port Lamont","Port Talbot","Portree","Portsmouth",
    "Purfleet","Queenborough","Redcar","Ridham Dock","Rochester","Rosyth","Rothesay","Rowhedge","Runcorn","Salford","Salt Island","Saltburn",
    "Saltend","Scalloway","Scapa Flow","Scrabster","Seaham","Seal Sands","Sharpness and Gloucester","Shell Haven","Shoreham","Silvertown",
    "Southampton","St Mary’s (Scilly Islands)","Stanlow","Stornoway","Stranraer","Sullom Voe","Sunderland","Swansea","Teesport","Teignmouth",
    "Thamesport","Thetwall","Tilbury","Torbay Harbour","Torquay","Totnes","Tranmere Oil Terminal","Truro","Tyne","Warrington","Wemyss Bay",
    "Weston Point","Whitehaven","Wick","Wivenhoe","Workington"
  ]},
  "United States": { flag: "", ports: [
    "Aberdeen","Baltimore","Baton Rouge","Boston","Brunswick","Camden","Charleston","Chester","Chicago","Cleveland","Columbia","Corpus Christi",
    "Duluth-Superior","Dundalk","Dutch Harbor","East Bay","Eddystone","El Segundo Terminal","Elizabeth","Eufaula","Eureka","Everett","Everglades",
    "Fairport Harbor","Fall River","Ferndale","Fort Lauderdale","Fort Pierce","Freeport","Galena Park","Galveston","Geismar","Girard Point",
    "Grays Harbor","Greens Bayou","Greenwich Point","Gretna","Groton","Gulfport","Haines","Hampton Roads","Hawkins Point","Hercules",
    "Hillsborough Bay","Hilo","Honolulu","Hoquiam","Houston","Humboldt Bay","Jacintoport","Jacksonville","Jeffries Point","Juneau","Key West",
    "Kodiak","Lake Calumet Harbor","Lake Charles","Lemont","Locust Point","Long Beach","Los Angeles","Lummus Island","Manchester","March Point",
    "Marcus Hook","Mare Island","Marrero","Martinez","McDuffie Island","Melville","Meraux","Miami","Milwaukee","Mobile","Montgomery",
    "Morehead City","National City","Nederland","New Bedford","New Haven","New Jersey","New London","New Orleans","New York & New Jersey",
    "Newark","Newport (Rhode Island)","Newport News","Nikiski","Nome","Norfolk","North Kingstown","Northport","Northville","Oleum","Orange","Ozol",
    "Palm Beach","Panama City","Pasadena","Paulsboro","Penns Grove","Pennsauken","Pensacola","Perth Amboy","Philadelphia","Phoenix City",
    "Piney Point","Pittsburg","Port Arthur","Port Canaveral","Port Chester Harbor","Port Covington","Port Everglades","Port Huron","Port Isabel",
    "Port Jefferson","Port Manatee","Port Neches","Port Newark","Port Richmond","Port San Luis","Port St Joe","Port Sutton","Port Townsend",
    "Portland (Maine)","Portland (Oregon)","Portsmouth","Portsmouth (New Hampshire)","Providence","Rattlesnake","Revere","Richmond (Virginia)",
    "Riverhead Terminal","Rockport","Sabine","Salem","San Diego","San Francisco","San Pedro Harbor","Sandwich","Santa Barbara","Savannah",
    "Searsport","Seattle","Selby","Selma","Seward","Sitka","Skagway","Smith’s Bluff","South Locust Point","Sparrow’s Point","St Bernard Port",
    "St Petersburg","Stamford Harbor","Stockton","Superior","Tacoma","Tampa","Texas City","Texport","Three Mile Creek","Tiverton","Tuscaloosa",
    "Unalaska","Valdez","Vallejo","Vancouver","Weedon Island","West Wego","Whittier","Wilmington (Delaware)","Wilmington (North Carolina)",
    "Winterport","Yorktown"
  ]},
  "Uruguay" : { flag:"https://flagcdn.com/w320/uy.png", ports:["Montevideo", "Nueva Palmira","Paysandu"]},
  "Venezuela": {
    flag: "https://flagcdn.com/w320/ve.png",
    ports: [
      "Alcasa",
      "Amuay Bay",
      "Bachaquero",
      "Bajo Grande Refinery",
      "Borburata",
      "Caripito",
      "Cumarebo",
      "El Chaure",
      "El Palito",
      "El Tablizo",
      "Guaraguao",
      "Guaranao",
      "Guiria",
      "La Estacada",
      "La Guaira",
      "Las Piedras",
      "Los Cocos",
      "Maracaibo",
      "Moron",
      "Palua",
      "Pamatacual",
      "Paradero",
      "Pertigalete",
      "Puerto Cabello",
      "Puerto La Cruz",
      "Puerto Miranda",
      "Puerto Ordaz",
      "Punta Cardon",
      "Punta Cuchillo",
      "Punta de Palmas",
      "San Felix",
      "San Lorenzo",
      "Venterminales"
    ]
  },
  
  "Virgin Islands (US)": {
    flag: "https://flagcdn.com/w320/vi.png",
    ports: [
      "Charlotte Amalie",
      "Christiansted",
      "Frederiksted",
      "Hovic",
      "Limetree Bay",
      "Port Alucroix",
      "St Thomas",
      "Third Port"
    ]
  },
  "Vietnam": {
    flag: "https://flagcdn.com/w320/vn.png",
    ports: [
      "Ben Nghe",
      "Cho-Lon",
      "Danang",
      "Haiphong",
      "Ho Chi Minh City",
      "Nha Be",
      "Saigon"
    ]
  },
  "Yemen": {
    flag: "https://flagcdn.com/w320/ye.png",
    ports: [
      "Aden",
      "Hodeldah",
      "Khalf Harbour",
      "Little Aden",
      "Ma’alla Terminal",
      "Mokha",
      "Mukalla",
      "Ras Alkatheeb",
      "Saleef"
    ]
  },
  };
    
    // ISO-2 map for the countries/regions you listed (FlagCDN wants lowercase ISO2)
    const ISO2 = {
      // A
      "Antigua": "ag",
      "Angola": "ao",
      "Algeria": "dz",
      "Albania": "al",
      "Argentina": "ar",
      "Ascension Island": "sh",      // fallback to Saint Helena (parent)
      "Aruba": "aw",
      "Australia": "au",
      "Azores": "pt",                // fallback to Portugal (parent)
    
      // B
      "Bahamas": "bs",
      "Bahrain": "bh",
      "Bangladesh": "bd",
      "Barbados": "bb",
      "Belgium": "be",
      "Belize": "bz",
      "Benin": "bj",
      "Bermuda": "bm",
      "Brazil": "br",
      "Brunei Darussalam": "bn",
      "Bulgaria": "bg",
    
      // C
      "Cameroon Republic": "cm",     // Cameroon
      "Canada": "ca",
      "Cayman Islands": "ky",
      "Cape Verde Islands": "cv",    // Cabo Verde
      "Canary Islands": "es",        // fallback to Spain (parent)
      "Chile": "cl",
      "China": "cn",
      "Cocos Islands": "cc",
      "Christmas Island": "cx",
      "Colombia": "co",
      "Costa Rica": "cr",
      "Congo (Democratic Republic)": "cd",
      "Congo (Republic of Congo)": "cg",
      "Comoros": "km",
      "Croatia": "hr",
      "Cuba": "cu",
      "Cyprus": "cy",
    
      // D–F
      "Denmark": "dk",
      "Ecuador": "ec",
      "Dominican Republic": "do",
      "Dominica": "dm",
      "Djibouti": "dj",
      "Egypt": "eg",
      "Fiji": "fj",
      "Faroe Islands": "fo",
      "Falkland Islands": "fk",
      "Estonia": "ee",
      "Eritrea": "er",
      "Equatorial Guinea": "gq",
      "El Salvador": "sv",
      "Finland": "fi",
      "France": "fr",
      "French Polynesia": "pf",
    
      // G
      "Georgia": "ge",
      "Gambia": "gm",
      "Gabon": "ga",
      "Germany": "de",
      "Gibraltar": "gi",
      "Ghana": "gh",
      "Greece": "gr",
      "Guyana": "gy",
      "Guinea-Bissau": "gw",
      "Guinea": "gn",
      "Guatemala": "gt",
      "Guam": "gu",
      "Guadeloupe": "gp",
      "Grenada": "gd",
      "Greenland": "gl",
      "Honduras": "hn",
      "Haiti": "ht",
      "Hong Kong": "hk",
      "Iceland": "is",
      "India": "in",
      "Indonesia": "id",
      "Iran": "ir",
      "Iraq": "iq",
      "Ireland": "ie",
      "Israel": "il",
      "Isle of Man": "im",
      "Italy": "it",
      "Jamaica": "jm",
      "Ivory Coast": "ci",
      "Japan": "jp",
      "Kenya": "ke",
      "Jordan": "jo",
      "Kiribati": "ki",
      "Korea (North)": "kp",
      "Korea (South)": "kr",
      "Kuwait": "kw",
      "Latvia": "lv",
      "Lebanon": "lb",
      "Liberia": "lr",
      "Libya": "ly",
      "Madeira": "pt",
      "Madagascar": "mg",
      "Lithuania": "lt",
      "Malaysia": "my",
      "Mauritius": "mu",
      "Mauritania": "mr",
      "Martinique": "mq",
      "Malta": "mt",
      "Mexico": "mx",
      "Myanmar": "mm",
      "Mozambique": "mz",
      "Morocco": "ma",
      "Monaco": "mc",
      "Micronesia": "fm",
      "Nauru": "nr",
      "Namibia": "na",
      "Netherlands": "nl",
      "New Caledonia": "nc",
      "Netherlands Antilles": "nl", // deprecated (fallback to NL)
      "New Zealand": "nz",
      "Nigeria": "ng",
      "Nicaragua": "ni",
      "Norway": "no",
      "Papua New Guinea": "pg",
      "Panama": "pa",
      "Pakistan": "pk",
      "Oman": "om",
      "Peru": "pe",
      "Philippines": "ph",
      "Puerto Rico": "pr",
      "Portugal": "pt",
      "Poland": "pl",
      "Qatar": "qa",
      "Romania": "ro",
      "Reunion": "re",
      "Russia": "ru",
      "South Africa": "za",
      "Somalia": "so",
      "Solomon Islands": "sb",
      "Slovenia": "si",
      "Singapore": "sg",
      "Sierra Leone": "sl",
      "Seychelles": "sc",
      "Serbia & Montenegro": "rs", // fallback to Serbia
      "Senegal": "sn",
      "Saudi Arabia": "sa",
      "São Tomé and Príncipe": "st",
      "Samoa": "ws",
      "Spain": "es",
      "Suriname": "sr",
      "Sudan": "sd",
      "St. Vincent": "vc",
      "St. Lucia": "lc",
      "St. Kitts & Nevis": "kn",
      "St. Helena Island": "sh",
      "Sri Lanka": "lk",
      "Sweden": "se",
      "Syria": "sy",
      "Tunisia": "tn",
      "Trinidad & Tobago": "tt",
      "Togo": "tg",
      "Thailand": "th",
      "Tanzania": "tz",
      "Taiwan": "tw",
      "Turkey": "tr",
      "United Arab Emirates": "ae",
      "Ukraine": "ua",
      "United Kingdom": "gb",
      "United States": "us"
    };
    
    // Build a valid FlagCDN URL
    const flagUrl = (iso2) => `https://flagcdn.com/w320/${iso2.toLowerCase()}.png`;
    
    // Fill missing/empty flags safely (uses parent-country fallbacks above)
    for (const [name, obj] of Object.entries(countriesWithPorts)) {
      if (!obj.flag) {
        const code = ISO2[name];
        obj.flag = code ? flagUrl(code) : ""; // keep empty if truly unknown
      }
    }
    
     
    
     const allCountries = Object.entries(countriesWithPorts).map(([name, v]) => ({
      value: name,
      label: name,
      flag: v.flag
    }));
    
      

      const [dischargeCountry, setDischargeCountry] = useState("");

const [dropdownOpenDis, setDropdownOpenDis] = useState(false);
const [hoverCountryDis, setHoverCountryDis] = useState("");
const [countryQueryDis, setCountryQueryDis] = useState("");
    

       const handleSubmitCharter = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();

    // Append text fields
    formData.append("type_of_cargo", TypeOfCargo);
        formData.append("tonnage", Tonnage);
        formData.append(
  "loading_port", LoadingPort
);
        formData.append(
  "discharge_port",
  DischargePort
);
        formData.append("lychan", Lychan);
        if('email'===null || Email===null){
      formData.append("email", '')
    }else{
      formData.append("email", Email);
    }
        if('url'===null || url===null){
      formData.append("url_new", '')
    }else{
      formData.append("url_new", url);
    }
        formData.append("phone", MobileNO);
        formData.append("brief_description", BriefDescription);
        formData.append("name", name);
        formData.append("company_address", CompanyAddress);
        
        formData.append("charterer_account", ChartererAcc);
        formData.append("commission", Commission);
    try {
           const response = await axios.put(
    `${config.base_url}/api/HappyMarineShipping/updateLogistics/${id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Token ${token}`
      },
             }
           );
           console.log("API Response:", response.data);
           if (response.data.status === 200) {
            navigate(-1);
             setLoading(false);
             toast.success("Registered Successfully!", {
               autoClose: 1500,
               position: 'top-right',
             });
       
             // Reset form state
             setCount(id);
             
           } else {
             setLoading(false);
             toast.error("Fill the required Fields", {
               autoClose: 1500,
               position: "top-right",
             });
           }
         } catch (err) {
      setLoading(false);
      console.error("Error:", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };
    
      useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, [pathname]);
    
    //   const allCountries = Object.entries(regions).flatMap(([region, countries]) =>
    //       countries.map((country) => ({
    //         ...country,
    //         region,
    //       }))
    //     );
    



    
      // Close dropdown on outside click
     useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
            setActiveRegion(null);
            setHoveredRegion(null);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
          
  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}
          
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
       {/* Sidebar */}
                       <div
                         className={`${
                           isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
                         }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
                       >
                         <ul className="mt-10 flex flex-col gap-3 ">
                           {/* Dashboard */}
                           <li className="px-4 py-2 text-lg   flex items-center">
                             <i className="fa-solid fa-gauge mr-3"></i>
                             {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                           </li>
               
                           {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
               
                           {/* Ship For Sale Dropdown */}
                           <li className="px-2   text-lg  flex flex-col  relative">
                             <div
                               className="flex items-center  justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                             >
                               <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Ship For Sale</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 1 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 1
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-2  text-lg  flex flex-col relative">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Ship For Charter</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
                             {!isSidebarOpen && openDropdown === 2 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 2
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                            <li className="px-2  text-lg flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                  <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Open Cargo </span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 3 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/addcargo'>Add Cargo</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/viewCargo' >View Cargo</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 3
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/addcargo'>Add Cargo</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/viewCargo' >View Cargo</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-2  text-lg  flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                  <h1 className="text-xl text-center font-semibold">-</h1>
                                 {isSidebarOpen && <span>Supply Equipments </span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 4 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 text-[#8D97AD] py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 4
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 text-[#8D97AD] py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                            
                          {isSidebarOpen && (
                                        <div className="px-5 mt-2 w-[75%]">
                                          <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                                            Approvals
                                          </h1>
                                        </div>
                                      )}
                                      {isSidebarOpen && (
                                        <ul className="px-2  text-lg flex flex-col relative group">
                                          <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforsale"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Ships For Sale
                                            </Link>
                                            {newShip && (
                                              <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                New
                                              </span>
                                            )}
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforCharterApp"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Ship For Charter
                                            </Link>
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                            to='/admin/LogisticsAppr'
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Open Cargo
                                            </Link>
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforEqApp"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Supply Equipments
                                            </Link>
                                          </li>
                                        </ul>
                                      )}
               
                           {/* Settings Dropdown */}
                           <li className="px-3 py-2 text-lg flex flex-col relative group">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                               onClick={() => toggleDropdown(6)}
                             >
                               <div className="flex items-center gap-2">
                                 <i className="fa-solid fa-gear"></i>
                                 {isSidebarOpen && <span>Settings</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {/* Hover Dropdown (Closed Sidebar) */}
                             {!isSidebarOpen && openDropdown === 6 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                 <ul>
                                   <li className="px-4 py-2 hover:bg-gray-100">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-4 py-2 hover:bg-gray-100">
                                   <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Click Dropdown (Open Sidebar) */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 6
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-3 py-1 hover:text-[#00c292]">
                                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
                         </ul>
                       </div>
               
                       {/* mobile screen sidebar */}
               
                       <div
                         className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
                           isMobile
                             ? isSidebarOpen
                               ? "w-full translate-x-0" // Open in full width on mobile
                               : "-translate-x-full w-0" // Hide sidebar on mobile
                             : isSidebarOpen
                             ? "w-60 translate-x-0" // Open normally on desktop
                             : "w-0" // Hide sidebar on desktop
                         }`}
                       >
                         <ul className="mt-10 flex flex-col gap-3 ">
                           {/* Dashboard */}
                           <li className={`px-4 py-2 text-lg    flex items-center`}>
                             {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
                             {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                           </li>
                          {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
                           {/* Ship For Sale Dropdown */}
                           <li
                             className={`px-2  text-lg  flex flex-col  relative`}
                           >
                             <div
                               className="flex items-center  justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                             >
                               <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                 {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Ship For Sale</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 1 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 1
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addShip">Add Ships</Link>
                                   </li>
                                   <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                                     <Link to="/admin/viewShip">View Ships</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-3  text-lg  flex flex-col relative">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Ship For Charter</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
                             {!isSidebarOpen && openDropdown === 2 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 2
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/addCharter">Add Charter</Link>
                                   </li>
                                   <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                     <Link to="/admin/shipforCharter">View Charter</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                            <li className="px-3  text-lg flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Open Cargo</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 3 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/addcargo'>Add Cargo</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/viewCargo' >View Cargo</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 3
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/addcargo'>Add Cargo</Link>
                                   </li>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                      <Link to='/admin/viewCargo' >View Cargo</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-3 text-lg  flex flex-col relative group ">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2"
                               onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                             >
                               <div className="flex items-center hover:text-[#00c292] gap-2">
                                 {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                 {isSidebarOpen && <span>Supply Equipments</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {!isSidebarOpen && openDropdown === 4 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Dropdown Content */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 4
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                     <Link to="/admin/addsEq">Add Equipments</Link>
                                   </li>
                                   <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                                     <Link to="/admin/shipforEq">View Equipments</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
               
                           <li className="px-3 text-lg flex flex-col relative group">
                                                   {/* Clickable Div */}
                                                   {isSidebarOpen && (
                                                     <div className="px-5  w-[50%]">
                                                       <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                                                         Approvals
                                                       </h1>
                                                     </div>
                                                   )}
                                     
                                                   {isSidebarOpen && (
                                                     <ul
                                                       className="px-2 py-2  text-lg flex gap-3
                                                                                                                    flex-col relative group"
                                                     >
                                                       <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforsale"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Ships For Sale
                                                         </Link>
                                                         {newShip && (
                                                           <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                             New
                                                           </span>
                                                         )}
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforCharterApp"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Ship For Charter
                                                         </Link>
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                         to='/admin/LogisticsAppr'
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Open Cargo
                                                         </Link>
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforEqApp"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Supply Equipments
                                                         </Link>
                                                       </li>
                                                     </ul>
                                                   )}
                                     
                                                   {/* Click Dropdown (For open sidebar) */}
                                                   {isSidebarOpen && (
                                                     <div
                                                       className={`ml-6 mt-2 transition-all duration-300 ${
                                                         openDropdown === 5
                                                           ? "max-h-48 opacity-100 "
                                                           : "max-h-0 opacity-0 overflow-hidden"
                                                       }`}
                                                     >
                                                       <ul>
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforsale"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Ships For Sale
                                                           </Link>
                                                           {newShip && (
                                                             <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                               New
                                                             </span>
                                                           )}
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforCharterApp"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Ship For Charter
                                                           </Link>
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                           to='/admin/LogisticsAppr'
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Open Cargo
                                                           </Link>
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforEqApp"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Supply Equipments
                                                           </Link>
                                                         </li>
                                                       </ul>
                                                     </div>
                                                   )}
                                                 </li>
               
               
               
                           {/* Settings Dropdown */}
                           <li className="px-3  text-lg flex flex-col relative group">
                             <div
                               className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                               onClick={() => toggleDropdown(6)}
                             >
                               <div className="flex items-center gap-2">
                                 {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                                 {isSidebarOpen && <span>Settings</span>}
                               </div>
                               {isSidebarOpen && (
                                 <i
                                   className={`fa-solid ${
                                     openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                   }`}
                                 ></i>
                               )}
                             </div>
               
                             {/* Hover Dropdown (Closed Sidebar) */}
                             {!isSidebarOpen && openDropdown === 6 && (
                               <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                 <ul>
                                   <li className="px-4 py-2 hover:bg-gray-100">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-3 py-1 hover:text-[#00c292]">
                                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
               
                             {/* Click Dropdown (Open Sidebar) */}
                             {isSidebarOpen && (
                               <div
                                 className={`ml-6 mt-2 transition-all duration-300 ${
                                   openDropdown === 6
                                     ? "max-h-40 opacity-100"
                                     : "max-h-0 opacity-0 overflow-hidden"
                                 }`}
                               >
                                 <ul>
                                   <li className="px-4 py-1 hover:text-[#00c292]">
                                     <Link to="/admin/profile">Profile</Link>
                                   </li>
                                   <li className="px-3 py-1 hover:text-[#00c292]">
                                    <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                   </li>
                                 </ul>
                               </div>
                             )}
                           </li>
                         </ul>
                       </div>

        {/* Main Content */}
        <div className="flex-1 py-4 overflow-y-auto">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
          <div className="flex justify-between items-center">
              <h1>Edit Ship </h1>
              <div className="flex text-sm gap-2">
               <Link to={'/adminHome'}>Home</Link> <span>/</span>
               <p className="text-[#00c292]">Edit Ship Category</p>
              </div>
            </div>
          </div>
          <div className="w-full py-5 px-4">
         <form className="bg-white mt-2 rounded w-full">
  <div className="p-5  flex justify-between items-center">
    <h1 className="text-black font-bold text-xl">Edit Cargo</h1>
    {url && url.trim() !== "" && (
    <button
      onClick={() => window.open(url, "_blank")}
      className="bg-blue-600 mt-1 transition-all duration-300 hover:bg-blue-500 rounded px-2 py-1 text-white"
    >
      Ref Email
    </button>
  )}
  </div>
  <hr className="text-gray-100 w-full" />

  {/* Type of Cargo */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="TypeOfCargo" className="font-semibold w-[170px] xm:w-full">
        Type Of Cargo
      </label>
      <input
        value={TypeOfCargo}
        onChange={(e) => setTypeOfCargo(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="TypeOfCargo"
        placeholder="Enter Type Of Cargo"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Tonnage" className="font-semibold w-[170px] xm:w-full">
        Tonnage
      </label>
      <input
        value={Tonnage}
        onChange={(e) => setTonnage(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Tonnage"
        placeholder="Enter Tonnage"
      />
    </div>
  </div>

  {/* Loading & Discharge Port */}
  
{/* Loading Port */}
<div className="flex items-center p-5 xm:flex-wrap">
  <label htmlFor="LoadingPort" className="font-semibold w-[170px] xm:w-[100%]">
    Loading Port
  </label>
  <input
    id="LoadingPort"
    type="text"
    placeholder="Enter loading port (e.g., Fujairah, UAE)"
    value={LoadingPort}
    onChange={(e) => setLoadingPort(e.target.value)}
    className="flex-1 rounded border border-gray-400 p-2 text-gray-600 bg-white"
  />
</div>

{/* Discharge Port */}
<div className="flex items-center p-5 xm:flex-wrap">
  <label htmlFor="DischargePort" className="font-semibold w-[170px] xm:w-[100%]">
    Discharge Port
  </label>
  <input
    id="DischargePort"
    type="text"
    placeholder="Enter discharge port (e.g., Mumbai, India)"
    value={DischargePort}
    onChange={(e) => setDischargePort(e.target.value)}
    className="flex-1 rounded border border-gray-400 p-2 text-gray-600 bg-white"
  />
</div>


  {/* Lychan & Charterer */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Lychan" className="font-semibold w-[170px] xm:w-full">
        Lychan
      </label>
      <input
        value={Lychan}
        onChange={(e) => setLychan(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Lychan"
        placeholder="Enter Lychan"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="ChartererAcc" className="font-semibold w-[170px] xm:w-full">
        Charterer/Shipper
      </label>
      <input
        value={ChartererAcc}
        onChange={(e) => setChartererAcc(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="ChartererAcc"
        placeholder="Enter Charterer Account/Shipper"
      />
    </div>
  </div>

  {/* Commission */}
  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Commission" className="font-semibold w-[170px] xm:w-full">
        Commission
      </label>
      <input
        value={Commission}
        onChange={(e) => setCommission(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Commission"
        placeholder="Enter Commission"
      />
    </div>
  </div>

  {/* Contact Information */}
  <div className="p-5">
    <h1 className="font-bold text-xl">Contact Information</h1>
    <hr className="border border-gray-200 w-full" />
  </div>

  <div className="p-5 flex flex-col gap-4">
    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Name" className="font-semibold w-[170px] xm:w-full">
        Name of the Broker
      </label>
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Name"
        placeholder="Enter Owner Name"
      />
    </div>

    

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="CompanyAddress" className="font-semibold w-[170px] xm:w-full">
        Company Address
      </label>
      <input
        value={CompanyAddress}
        onChange={(e) => setCompanyAddress(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="CompanyAddress"
        placeholder="Enter Company Address"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="Email" className="font-semibold w-[170px] xm:w-full">
        Email
      </label>
      <input
        value={Email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="Email"
        placeholder="Enter Email"
      />
    </div>

    <div className="flex items-center xm:flex-col xm:items-start ">
      <label htmlFor="MobileNo" className="font-semibold w-[170px] xm:w-full">
        Mobile No
      </label>
      <input
        value={MobileNO}
        onChange={(e) => setMobileNO(e.target.value)}
        className="flex-1 xm:w-full rounded border border-gray-400 p-2 text-gray-500"
        id="MobileNo"
        placeholder="Enter Mobile Number"
      />
    </div>
  </div>


  
      <div className="flex p-5 items-center gap-3">
      <label htmlFor="URL" className="font-semibold w-[150px]">
       URL
      </label>
      <input
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Url"
        placeholder="Enter Your Url"
      />
    </div>
    

  {/* Additional Info */}
  <div className="p-5 flex flex-col gap-3">
    <label htmlFor="BriefDescription" className="font-semibold">
      Additional Informations
    </label>
    <textarea
      value={BriefDescription}
      onChange={(e) => setBriefDescription(e.target.value)}
      className="w-full rounded border border-gray-400 p-2 text-gray-500"
      id="BriefDescription"
      rows={5}
      placeholder="More info..."
    />
  </div>

  <hr className="text-gray-500 w-full" />
  <div className="p-4">
    <button
      type="submit"
      onClick={(e) => handleSubmitCharter(e)}
      className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded"
    >
      Submit
    </button>
  </div>
</form>
          </div>
        </div>
      </div>
    </div>
  );
}
